import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { icon, latLng, LatLng, Map, marker, tileLayer } from 'leaflet';

@Component({
  selector: 'app-locator',
  templateUrl: './locator.component.html',
  styleUrls: ['./locator.component.scss']
})
export class LocatorComponent implements OnInit {

  constructor() { }
  @Input() row;
  @Output() done: EventEmitter<object> = new EventEmitter<object>();
  layers: any = [];
  mapOptions = {
    layers: [tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; Petiak System'
    })],
    zoom: 17,
    center: latLng([35.7788807, 51.4342467])
  };
  layersControl = {
    baseLayers: {
      'Open Street Map': tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' }),
      'Wikimedia': tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' })
    }
  };
  map;
  marker;

  ngOnInit() {

  }
  onMapReady(map: Map) {
    map.invalidateSize();
    this.map = map;
    this.map.on('zoom', () => {
      this.makeCenter();
    });
    this.map.on('move', () => {
      this.makeCenter();
    });
    if (!this.row && navigator.geolocation) {
      map.invalidateSize();
      navigator.geolocation.getCurrentPosition((position2) => {
        setTimeout(() => {
          map.flyTo(new LatLng(position2.coords.latitude, position2.coords.longitude));
        }, 100);
      }, console.error, { enableHighAccuracy: false, maximumAge: Infinity, timeout: 60000 });
    } else if (this.row && this.row.latitude && this.row.longitude) {
      map.invalidateSize();
      setTimeout(() => {
        map.flyTo(new LatLng(this.row.latitude, this.row.longitude));
      }, 100);
    }
    const center = this.map.getBounds().getCenter();
    this.marker = marker(center, {
      icon: icon({
        iconUrl: `assets/images/leaflet/marker.png`,
        iconSize: [48, 48]
      })
    });
    this.marker.on('mouseup', (event) => {
      this.done.emit(event.latlng);
    });
    this.layers.push(this.marker);

  }


  private makeCenter() {
    this.map.invalidateSize();
    const center = this.map.getBounds().getCenter();
    if (center && this.marker) { this.marker.setLatLng(center); }
  }

}
